<template>
    <v-container fluid>
        <v-row class="pl-2 pr-2" style="justify-content: center">
            <v-col cols="4" lg="4" md="12" sm="12" xs="12">
                <v-card
                    color="success"
                    @click="groupsIndex()"
                >
                    <v-card-title class="white--text justify-center" style="font-size: 50px;font-weight: bold;">
                        {{ groups.length }}
                    </v-card-title>
                    <v-card-title class="white--text justify-center">Groups</v-card-title>
                </v-card>
            </v-col>
            <v-col cols="4" lg="4" md="12" sm="12" xs="12">
                <v-card
                    color="blue"
                    @click="outletsIndex()"
                >
                    <v-card-title class="white--text justify-center" style="font-size: 50px;font-weight: bold;">
                        {{ outlets.length }}
                    </v-card-title>
                    <v-card-title class="white--text justify-center">Outlets</v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-card-title>Groups</v-card-title>
        <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    hide-details
                    class="ma-1"
                    outlined
                ></v-text-field>
            </v-col>
            <v-col style="text-align: right;" class="pr-12">
                <v-btn class="ma-1"
                       small
                       color="success"
                       @click="create()"> + Add Group
                </v-btn>
            </v-col>
        </v-row>
        <v-card
            max-height="400"
        >
            <v-data-table
                :headers="headers"
                item-key="name"
                :items="Object.values(groups)"
                :search="search"
                dense
                class="display-3 font-weight-medium"
                items-per-page="30"
                fixed-header="true"
                height="400"
            >
                <template v-slot:item.actions="{ item }">
                    <v-icon
                        class="mr-8"
                        @click="edit(item)"
                    >
                        mdi-pencil
                    </v-icon>
                    <v-icon
                        color="red"
                        @click="deleteGroup(item)"
                    >
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import AdminLayout from './Layouts/Admin'

export default {
    name: 'Dashboard',
    props: ['groups', 'outlets'],
    components: {
        AdminLayout,
    },
    data: () => ({
        headers: [
            {
                text: 'ID',
                align: 'start',
                value: 'id',
            },
            {
                text: 'Group',
                align: 'start',
                value: 'name',
            },
            {
                text: 'Description',
                value: 'description',
            },
            {
                text: 'Actions',
                value: 'actions',
                sortable: false
            }
        ],
        search: null,
    }),
    methods: {
        groupsIndex() {
            window.location.href = '/groups'
        },
        outletsIndex() {
            window.location.href = '/outlets'
        },
    },
};
</script>

<style>
.v-data-table-header th {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard.vue